module.exports = __webpack_public_path__ + "img/product-type-item-bg.b627ef15.png";